/**
 * Shared AI utilities for parsing tool call results from messages.
 */

/**
 * Returns a filter/accessor function that extracts a specific key from a tool_result message.
 * Usage: messages.filter(getToolCallResult("project_id"))
 *        or: const value = getToolCallResult("canvas_id")(message)
 */
export const getToolCallResult = (key) => (message) => {
    if (message.type !== "tool_result") {
        return false;
    }
    const messageContent = message.content[0];
    if (!messageContent || messageContent.length === 0) {
        return false;
    }
    try {
        const textData = JSON.parse(messageContent.content);
        return textData.data[key];
    } catch (error) {
        return false;
    }
};

/**
 * Extracts the `type` field from a tool_result message's parsed content.
 */
export const getToolCallResultType = (message) => {
    if (message.type !== "tool_result") {
        return false;
    }
    const messageContent = message.content[0];
    if (!messageContent || messageContent.length === 0) {
        return false;
    }
    try {
        const textData = JSON.parse(messageContent.content);
        return textData.type;
    } catch (error) {
        return false;
    }
};

/**
 * Agent type constants for the multi-agent system.
 */
export const AGENT_TYPES = {
    ROUTER: "router",
    BRIEF: "brief",
    WRAP_REPORT: "wrap_report",
    TIMELINE: "timeline",
    BID: "bid",
};

/**
 * Maps agent_type to its tool set and prompt template identifiers.
 */
export const AGENT_CONFIG = {
    [AGENT_TYPES.ROUTER]: {
        toolSet: "project_router",
        promptTemplate: "project_router",
        label: "Project Assistant",
    },
    [AGENT_TYPES.BRIEF]: {
        toolSet: "project_brief",
        promptTemplate: "project_brief",
        label: "Brief Creator",
    },
    [AGENT_TYPES.WRAP_REPORT]: {
        toolSet: "project_wrap_report",
        promptTemplate: "project_wrap_report",
        label: "Wrap Report",
    },
    [AGENT_TYPES.TIMELINE]: {
        toolSet: "project_timeline",
        promptTemplate: "project_timeline",
        label: "Project Timeline",
    },
    [AGENT_TYPES.BID]: {
        toolSet: "bid_quickstart",
        promptTemplate: "bid_quickstart",
        label: "Bid Import",
    },
};
